import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

import Chip from '@mui/material/Chip';
import './MediaComponent.css';
import { AuthContext } from '../../../AuthContext';

import ImageViewer from '../ImageViewer/ImageViewer';
import { editImage, getImageById, getImageFileUrl, getImageThumbnailUrl } from '../../../services/mediaService';

const options = { timeZone: 'Europe/Budapest', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };

const Media = ({
  categories,
  size,
  currentIndex,
  data,
  onClick

}) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate(); // Initialize useNavigate
  const [isImageAvailable, setIsImageAvailable] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [token] = useState(localStorage.getItem('token') || '');

  const fullUrl = getImageThumbnailUrl(data[currentIndex].id);

  useEffect(() => {
    setIsImageAvailable(null);
    setImageLoaded(false);

    const image = new Image();
    image.src = fullUrl;

    image.onload = () => {
      setIsImageAvailable(true);
      setImageLoaded(true);
    };

    image.onerror = () => {
      setIsImageAvailable(false);
      setImageLoaded(false);
    };
  }, [fullUrl]);

  /*const handleImageClick = () => {
    localStorage.setItem('slideshowIndex', currentIndex);
    localStorage.setItem('data', JSON.stringify(data));

    //navigate(`/images/view/${data[currentIndex].id}`);
  };*/

  const getCategoryNames = (itemCategory, fallbackCategory, id) => {
    const itemCategories = [];
    let raw = itemCategory;
    if ((!raw || raw === '') && fallbackCategory) raw = fallbackCategory;

    if (Array.isArray(raw)) {
      raw.forEach((element) => {
        const id = parseInt(element);
        const category = categories.find((cat) => cat.id === id);
        itemCategories.push(category ? category.name : 'Ismeretlen kategória 1');
      });
      return itemCategories.length ? itemCategories : ['Ismeretlen kategória 2'];
    }

    if (typeof raw === 'string' && raw.trim().startsWith('[')) {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          return getCategoryNames(parsed);
        }
      } catch (e) {
        // fallthrough to treat as comma-separated
      }
    }

    if (typeof raw === 'string' && raw.includes(',')) {
      const parts = raw.split(',').map((s) => s.trim()).filter(Boolean);
      parts.forEach((element) => {
        const id = parseInt(element);
        const category = categories.find((cat) => cat.id === id);
        itemCategories.push(category ? category.name : 'Ismeretlen kategória 3');
      });
      return itemCategories.length ? itemCategories : ['Ismeretlen kategória 4'];
    }

    if (raw) {
      const id = parseInt(raw);
      if (!isNaN(id)) {
        const category = categories.find((cat) => cat.id === id);
        itemCategories.push(category ? category.name : 'Ismeretlen kategória 5');
        return itemCategories;
      }

      itemCategories.push(raw);
      return itemCategories;
    }

    return ['Ismeretlen kategória 6'];
  };

  return (
    <div className="media-cell">
      <div className="media-container" >
        {isImageAvailable === null ? (
          <span>Töltés...</span>
        ) : isImageAvailable ? (
          <img
            src={fullUrl}
            alt="Thumbnail"
            className={`thumbnail ${imageLoaded ? 'fade-in' : ''}`}
            style={{ width: size, height: size, cursor: 'pointer' }}
            onClick={onClick}
          />
        ) : (
          <i className="bi bi-file-earmark-image" style={{ fontSize: size }} />
        )}
        <div className="media-info">
          <p className="mb-0">Készítés ideje: {data[currentIndex].created_time ? new Date(data[currentIndex].created_time * 1000).toLocaleDateString('hu-HU') : '-'}</p>
          <p>Feltöltés ideje: {new Date(data[currentIndex].upload_time * 1000).toLocaleDateString('hu-HU')}</p>
          {getCategoryNames(data[currentIndex].categories, data[currentIndex].category, data[currentIndex].id).map((categoryName, index) => (
            index === 0 ? (
              <li key={index} className="main-category">
                {categoryName}
              </li>
            ) : (
              <Chip
                key={index}
                label={categoryName}
                className="sub-category-chip"
                style={{ margin: '4px' }}
              />
            )
          ))}
        </div>
      </div>

    </div>

  );
};

export default Media;
